import classes from "./Content.module.css";

export const Content = ({ title, searchBar, footer, children }) => {
  return (
    <div className={classes.content}>
      {title && <div className={classes.title}>{title}</div>}
      {searchBar && <div className={classes.search_bar}>{searchBar}</div>}
      {children ? <div className={classes.container}>{children}</div>:
      <div
          className={classes.table}
          style={{ backgroundColor: "transparent" }}
        ></div>}
      {footer && <div className={classes.footer}>{footer}</div>}
    </div>
  );
};
